/* global globalThis */
// Display reads only: bounded waiting, including the response body. Never use
// this helper to retry mutations, send messages or cancel server queue work.
export async function requestDisplayJson(url, init = {}, {
  timeoutMs = 20000, fetchImpl = globalThis.fetch, onHeaders,
} = {}) {
  const controller = new AbortController();
  let timer, onAbort;
  const cancelled = new Promise((_, reject) => {
    onAbort = () => {
      controller.abort();
      reject(Object.assign(new Error("Requisição cancelada"), { name:"AbortError" }));
    };
    if (init.signal?.aborted) onAbort();
    else init.signal?.addEventListener("abort",onAbort,{ once:true });
    timer = setTimeout(() => {
      controller.abort();
      reject(Object.assign(new Error("Não foi possível atualizar agora. Tente novamente."), {
        code:"request_timeout",
      }));
    },timeoutMs);
  });
  try {
    return await Promise.race([
      cancelled,
      Promise.resolve().then(async () => {
        if (controller.signal.aborted) throw Object.assign(new Error("Requisição cancelada"),{name:"AbortError"});
        const response = await fetchImpl(url,{...init,signal:controller.signal});
        onHeaders?.(response);
        const payload = await response.json();
        return { response,payload };
      }),
    ]);
  } finally {
    clearTimeout(timer);
    init.signal?.removeEventListener("abort",onAbort);
  }
}
